import breadcrumbTemplate from '../common/breadcrumb/breadcrumb.html';
import authServicesListTemplate from './authentication_services-list.html';
import authServicesEditTemplate from './authentication_services-edit.html';


angular.module('authenticationServices', ['ui.bootstrap.contextMenu'])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('authentication_services', {
                url: "/authenticationServices",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: breadcrumbTemplate,
            })

            .state('authentication_services.list', {
                url: "/list",
                controller: "authenticationServicesListCtrl",
                template: authServicesListTemplate,
                requiredPermission: ["AUTHENTICATION_SERVICES_READ"]
            })
            
            .state('authentication_services.edit', {
                url: "/edit/:id",
                controller: "authenticationServicesEditCtrl",
                template: authServicesEditTemplate,
           data: { pageTitle: "Servicio" },
                requiredPermission: ["AUTHENTICATION_SERVICES_WRITE"]
            })

    }])
;